import { styled } from "@mui/material"

export const ImageCellContainer = styled("img")(() => ({
    width: "24px",
    height: "24px",
}))
